import { render, staticRenderFns } from "./MyZs8.vue?vue&type=template&id=6199e47f&scoped=true&"
import script from "./MyZs8.vue?vue&type=script&lang=js&"
export * from "./MyZs8.vue?vue&type=script&lang=js&"
import style0 from "./MyZs8.vue?vue&type=style&index=0&id=6199e47f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6199e47f",
  null
  
)

export default component.exports